<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0">
          <div class="search-wrap">
            <div class="search-item">
                <label class="col-sm-2 control-label"> Category </label>
                <div class="col-sm-4">
                    <el-select v-model="searchParams.level" placeholder="Select" clearable>
                      <el-option
                        v-for="item in category"
                        :key="item.key"
                        :label="item.val"
                        :value="item.key">
                      </el-option>
                    </el-select>
                </div>
            </div>
            <div class="search-item">
                 <label class="col-sm-2 control-label"> Entry Number </label>
                <div class="col-sm-4 entry-no-wrap">
                    <el-input v-model="entryNumberHead" clearable placeholder="3 Char"></el-input>
                    <div class="separator"> - </div>
                    <el-input v-model="entryNumberBody" clearable placeholder="8 Char"></el-input>
                </div>
            </div>
            <div class="search-item">
                <label class="col-sm-2 control-label"> Submission Date </label>
                <div class="col-sm-4">
                  <el-date-picker
                    v-model="searchParams.submissionDate"
                    type="daterange"
                    start-placeholder="Start date"
                    end-placeholder="End date">
                  </el-date-picker>
                </div>
                <div class="btn-wrap">
                    <el-button @click="handleSearchList" type="primary" style="width:150px;">{{ $t("message.Search") }}</el-button>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0 table-wrap">
          <div style="flex:1">
            <div class="unassigned-entries-wrap">
              <div class="unassigned-entries-text">Unassigned Entries: </div>
              <div class="unassigned-entries">{{`${unassignedEntriesCurrent} / ${unassignedEntriesTotal}`}}</div>
            </div>
            <el-table :data="unSelStemupList" :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange" style="border:2px solid black;">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column type="index" label="S/N" fixed width="60">
              </el-table-column>
              <el-table-column prop="submissionId" label="Submission ID">
              </el-table-column>
              <el-table-column prop="submissionDate" label="Submission Date">
              </el-table-column>
              <el-table-column prop="uploadCode" label="Entry Number">
              </el-table-column>
            </el-table>
            <el-col :span="24" class="el-table_footertoolbar">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleUnSelPageSizeChange"
                @current-change="handleUnSelPageCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                :total="unSelTotal"
                style="float: right"
              >
              </el-pagination>
            </el-col>
          </div>
          <div class="button-wrap">
            <el-button type="primary" icon="el-icon-bottom" @click="handleAssignToGroup">Assign</el-button>
          </div>
        </div>
       </div>
       <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0 table-wrap">
          <el-tabs v-model="currentGroupId" type="card" @tab-click="handleSelectionChangeByGroupList" style="flex:1" :before-leave='handleIsAddGroup'>
            <el-tab-pane :label="`${item.groupName} (${item.entryCount})`" :name="item.id+''" v-for="item in groupList" :key="item.id">
              <el-table :data="JudgeEntryByGroupList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectGroupItem" style="border:2px solid black;">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column type="index" label="S/N" fixed width="60">
                </el-table-column>
                <el-table-column prop="submissionId" label="Submission ID">
                </el-table-column>
                <el-table-column prop="submissionDate" label="Submission Date">
                </el-table-column>
                <el-table-column prop="uploadCode" label="Entry Number">
                </el-table-column>
                <el-table-column prop="assignedBy" label="Assigned By"></el-table-column>
              </el-table>
               <el-col :span="24" class="el-table_footertoolbar">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleGroupPageSizeChange"
                @current-change="handleGroupPageCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="item?item.pageSize:0"
                :total="item?item.groupTotal:0"
                style="float: right"
              >
              </el-pagination>
            </el-col>
            </el-tab-pane>
            <el-tab-pane name="addGroup">
              <span slot="label"><i class="el-icon-plus"></i> Add Panel</span>
            </el-tab-pane>
          </el-tabs>
            
          <div class="button-wrap" style="padding-top:40px;">
            <el-button type="primary" icon="el-icon-top" @click="handleRemoveToUnSel">Remove</el-button>
          </div>
        </div>
       </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios"

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      unSelCheckedList:[],
      groupCheckedList:[],
      unSelTotal:0,
      userInfo:{
        userId:null,
        token:''
      },
      currentGroupId:'0',
      JudgeEntryByGroupList:[],
      groupList:[],
      unSelStemupList:[],
      entryNumberHead:'',
      entryNumberBody:'',
      searchParams:{
        level:'',
        entryNo:'',
        submissionDate:'',
        pageIndex:1,
        pageSize:10,
      },
      unassignedEntriesCurrent:0,
      unassignedEntriesTotal:0,
    }
  },

  created() {
    this.intiPage()
  },
  mounted() {
  },
  components: {},
  computed:{
    baseURL(){
      return config.domain+'/'
    },
    category() {
      return [
        {key:5,val:"Primary School"},
        {key:6,val:"Secondary School"},
        {key:7,val:"Open"}
      ]
    },
    entryNumber(){
      if(this.entryNumberHead && this.entryNumberBody) return this.entryNumberHead + '-' + this.entryNumberBody
      else if(this.entryNumberHead) return this.entryNumberHead
      else if(this.entryNumberBody) return this.entryNumberBody
      else return ''
    },
  },
  methods: {
    async intiPage(){
      this.getUserInfo()
      await this.handleSearchList()
      await this.getGroupList()
      await this.handleSelectionChangeByGroupList()
      this.computedUnassignedEntries()
    },
     computedUnassignedEntries(){
      this.unassignedEntriesCurrent = this.unSelTotal
      this.unassignedEntriesTotal = this.groupList.reduce((total,item)=>{
        return total + item.entryCount
      },0) + this.unassignedEntriesCurrent
    },
    getUserInfo(){
      this.userInfo=this.getAuthObj();
    },
    async getGroupList(){
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getHsbcEntryGroupList', {...this.userInfo})
      if(status_code=='0') {
        this.groupList= result
        this.groupList.forEach(i=>{
          i.pageIndex=1,
          i.pageSize=10,
          i.groupTotal=0
        })
        if(this.groupList.length && !Number(this.currentGroupId)) this.currentGroupId = this.groupList[0].id + ''
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async handleSearchList(){
      const params={
        ...this.searchParams,
        entryNo:this.entryNumber
      }
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getHsbcUnSelStemupList', {...this.userInfo,...params})
      if(status_code=='0') {
        this.unSelTotal=result.total
        this.unSelStemupList=result.judgeEntryList
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async handleSelectionChangeByGroupList(tab){
      if(tab&&(tab.name=="addGroup")) return this.addGroup()
      const id =tab?tab.name:this.currentGroupId
      let groupRow=this.groupList.find(i=>{
        return i.id+'' == id
      })
      if(!groupRow) return
      const param={
        ...this.userInfo,
        groupId:id,
        pageIndex:groupRow?groupRow.pageIndex:1,
        pageSize:groupRow?groupRow.pageSize:10
      }
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getHsbcJudgeEntryByGroup', param)
      if(status_code=='0') {
        this.JudgeEntryByGroupList=result.judgeEntryList
        groupRow.groupTotal=result.total
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handleSelectGroupItem(val){
      this.groupCheckedList=val
    },
    handleSelectionChange(val){
      this.unSelCheckedList=val
    },
    handleUnSelPageSizeChange (val){
      this.searchParams.pageSize = val;
      this.handleSearchList()
    },
    handleUnSelPageCurrentChange (val){
      this.searchParams.pageIndex = val;
      this.handleSearchList()
    },
    handleGroupPageSizeChange (val){
      const group = this.groupList.find(i =>{
        return i.id+''  == this.currentGroupId
      })
      group.pageSize = val
      this.handleSelectionChangeByGroupList()
    },
    handleGroupPageCurrentChange (val){
      const group = this.groupList.find(i =>{
        return i.id+''  == this.currentGroupId
      })
      group.pageIndex = val
      this.handleSelectionChangeByGroupList()
    },
    async handleAssignToGroup(){
      if(!this.unSelCheckedList) return 
      let stemupUploadIds= ''
      this.unSelCheckedList.forEach((item,index)=>{
        if(this.unSelCheckedList.length-1>index) stemupUploadIds += item.id +','
        else stemupUploadIds += item.id
      })
      const params ={
        ...this.userInfo,
        groupId:this.currentGroupId,
        stemupUploadIds:stemupUploadIds
      }
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/assignEntry',params )
      if(status_code=='0') {
        this.unSelCheckedList=[]
        this.handleSearchList()
        this.handleSelectionChangeByGroupList()
        this.getGroupList()
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async handleRemoveToUnSel(){
      if(!this.groupCheckedList.length) return 
      let stemupUploadIds= ''
      this.groupCheckedList.forEach((item,index)=>{
        if(this.groupCheckedList.length-1>index) stemupUploadIds += item.id +','
        else stemupUploadIds += item.id
      })
      const params={
        ...this.userInfo,
        type:2, //1stemup 2hsbc 写死就好
        ids:stemupUploadIds
      }
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/removeEntry',params )
      if(status_code=='0') {
        this.groupCheckedList=[]
        this.handleSearchList()
        this.handleSelectionChangeByGroupList()
        this.getGroupList()
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
      handleIsAddGroup(name){
      if(name=="addGroup") return false
    },
    addGroup(){
      this.$confirm('Confirm to add a new Panel?', 'System Message', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'}).then(async () => {
            const lastGroupName=this.groupList.length?this.groupList[this.groupList.length-1].groupName:'0'
            const newGroupName='Panel ' + (Number(lastGroupName.charAt(lastGroupName.length-1)) + 1)
            const params={
              groupName:newGroupName,
              ...this.userInfo
            }
            const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/addHsbcGroup',params )
            if(status_code=='0') {
              this.getGroupList()
            }else{
              this.$store.getters.warning.warningMsg = status_message;
              this.$store.getters.warning.warningFalg = true;
            }
          }).catch(()=>{
            
          })
          
    },
  }
};
</script>

<style lang="scss" scoped>
.search-wrap{
    display:flex;
    flex-direction: column;
    .search-item{
        margin-bottom:15px;
        display:flex;
        .entry-no-wrap{
          display:flex;
          .separator{
            margin:0 10px;
            display:flex;
            align-items: center;
          }
        }
        .btn-wrap{
            display:flex;
            justify-self: flex-end;
        }
    }
}
.table-wrap{
  display:flex;
  .button-wrap{
    display:flex;
    justify-content: center;
    align-items: center;
    margin:0 50px;
  }
  .unassigned-entries-wrap{
    width:100%;
    display:flex;
    justify-content: flex-end;
    margin-bottom:10px;
    align-items: center;
    .unassigned-entries-text{
      margin-right:10px;
      font-size:14px;
    }
    .unassigned-entries{
      border-radius: 5px;
      width:70px;
      height:30px;
      border:1px solid black;
      display:flex;
      justify-content: center;
      align-items: center;
    }
  }
}
::v-deep .el-tabs__header{
  margin: 0;
}
</style>
